/** UGP profile properties — shared client helpers (mirrors api/constants/ugpProperties.js). */

export const ALL_USERS_SENTINEL = '00000000-0000-0000-0000-000000000000';

export const DEFAULT_PROPERTY_DEFINITIONS = {
  meeting_link: { label: 'Meeting link', kind: 'url' }
};

export const AUDIENCE_EVERYONE = { value: 'everyone', label: 'Everyone' };

export function normalizePropertyKey(key) {
  const k = String(key || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (!/^[a-z][a-z0-9_]*$/.test(k)) return null;
  return k;
}

export function mergePropertyDefinitions(assignmentMetadata = {}) {
  const defs = { ...DEFAULT_PROPERTY_DEFINITIONS };
  const fromMeta = assignmentMetadata?.property_definitions;
  if (fromMeta && typeof fromMeta === 'object') {
    Object.keys(fromMeta).forEach((k) => {
      const nk = normalizePropertyKey(k);
      if (!nk) return;
      defs[nk] = { ...(defs[nk] || {}), ...(fromMeta[k] || {}) };
    });
  }
  return defs;
}

export function getEnabledPropertyKeys(assignmentMetadata = {}) {
  const defs = mergePropertyDefinitions(assignmentMetadata);
  const enabled = assignmentMetadata?.enabled_properties;
  if (Array.isArray(enabled) && enabled.length) {
    return enabled.map(normalizePropertyKey).filter((k) => k && defs[k]);
  }
  return Object.keys(defs);
}

export function getPropertyLabel(key, assignmentMetadata = {}) {
  const defs = mergePropertyDefinitions(assignmentMetadata);
  const k = normalizePropertyKey(key);
  return defs[k]?.label || k || 'Property';
}

export function formatAudienceLabel(row) {
  if (row.audience_label) return row.audience_label;
  if (row.audience === 'everyone') return 'Everyone';
  if (row.audience === 'groups_periods') return 'Group period';
  if (row.audience === 'groups') return 'Group';
  return 'Audience';
}
